export const ASSISTANT_MODEL_KEEP_ALL_EVENT = 'assistant-model-changes:keep-all';
export const ASSISTANT_MODEL_UNDO_ALL_EVENT = 'assistant-model-changes:undo-all';
/** Fired when AI-applied input changes should be shown on the model input tab. */
export const ASSISTANT_MODEL_SHOW_INPUT_EVENT = 'assistant-model-changes:show-input';

export type ModelChangeAction = 'keep-all' | 'undo-all';

export const dispatchModelChangeAction = (action: ModelChangeAction): void => {
  const eventName = action === 'keep-all'
    ? ASSISTANT_MODEL_KEEP_ALL_EVENT
    : ASSISTANT_MODEL_UNDO_ALL_EVENT;

  window.dispatchEvent(new CustomEvent(eventName, {
    detail: {
      source: 'assistant-chat',
    },
  }));
};

/** Switch the model page to the Input tab so applied AI edits are visible. */
export const requestShowModelInputTab = (): void => {
  window.dispatchEvent(new CustomEvent(ASSISTANT_MODEL_SHOW_INPUT_EVENT, {
    detail: {
      source: 'assistant-chat',
    },
  }));
};
